module.exports = __webpack_public_path__ + "static/img/news.881d62b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/news.jpg
// module id = zuTN
// module chunks = 4